<template>
  <div class="slider-navigation d-flex gap-3">
    <button class="slider-navigation__prev icon-chevron-left"></button>
    <button class="slider-navigation__next icon-chevron-right"></button>
  </div>
</template>

<style lang="scss" scoped>
@import '~scssAsset/components/common/slider-navigation.scss';
</style>
